import { z } from 'zod';
import { Id, IsoDate } from './common';
import { NotificationCountsSchema, NotificationSchema } from './notifications';
import { MissionSummarySchema } from './work';
/* ============================================================================
   Server-Sent Events: GET /v1/stream (tenant) and GET /v1/hq/stream (platform).
   Auth: access token via `?access_token=` (EventSource can't set headers) or
   cookie. Server sends `: ping` comments every 25s; clients fall back to 30s
   polling of /v1/notifications/counts if the stream drops.
   Wire format:  event: <name>\n data: <JSON>\n id: <uuid>\n\n
   ========================================================================== */
export const SSE_EVENTS = {
    /** new notification for the current user */
    'notification.created': NotificationSchema,
    /** badge counts changed (after seen/read on another device) */
    'notification.counts': NotificationCountsSchema,
    /** a mission the user can see changed (list/board live update) */
    'mission.updated': z.object({ mission: MissionSummarySchema, by: Id.nullable() }),
    'mission.deleted': z.object({ id: Id, projectId: Id, by: Id.nullable() }),
    /** new comment/activity on a mission whose panel is open */
    'timeline.appended': z.object({ missionId: Id, itemId: Id, at: IsoDate }),
    /** a new web build was published → VersionGate shows the blocking refresh screen */
    'release.published': z.object({ version: z.string(), notes: z.array(z.string()) }),
    /** tenant became read-only/suspended or plan changed → refetch /v1/me */
    'tenant.state_changed': z.object({ status: z.string(), reason: z.string().nullable() }),
    /** forced sign-out (password changed elsewhere, session revoked) */
    'session.revoked': z.object({ sessionId: Id }),
};
/** Mission HQ stream events. */
export const HQ_SSE_EVENTS = {
    'hq.notification.created': z.object({ id: Id, title: z.string(), kind: z.string(), createdAt: IsoDate }),
    'hq.inquiry.created': z.object({ id: Id, tenantName: z.string() }),
    'hq.offer.claimed': z.object({ linkId: Id, tenantName: z.string() }),
    'hq.job.failed': z.object({ job: z.string(), error: z.string() }),
};
//# sourceMappingURL=sse.js.map